import template from './commercial-multi-area.jade';
import validation from './../../../services/validation';
import { trackClickIsAreaParts, trackFailAreaPart } from './tracking';
import { getClientDeviceType, isAreaPartsEnabled } from '../../../../../../shared/utils';

const PARTS_MAX_COUNT = 10;

export default angular
  .module('cian.addForm.commercialMultiArea', [])
  .directive('cianAfAboutObjectCommercialMultiArea', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
      categoryInfo: '=',
    },
    controller(deviceService, $scope) {
      'ngInject';
      let dealType;

      const isRent = this.categoryInfo.dealType === 'rent';
      if (this.categoryInfo.dealType === 'sale') {
        dealType = 'продажи';
        this.dealTypeTitle = 'продажа';
      } else if (isRent) {
        dealType = 'аренды';
        this.dealTypeTitle = 'аренда';
      }

      this.isMobile = deviceService.isMobile;

      const isOfferEditing = !!this.ad.id;
      const product = this.ad.id && {
        id: this.ad.id,
        offerType: 'offer',
        position: 1,
      };
      const siteType = getClientDeviceType();
      this.tooltipText = `Укажите размер частей общей площади помещения, доступных для ${dealType}`;

      this.areaMax = 9999999;
      this.areaMin = 0;
      this.hoverIndex = -1;

      this.isPartsEnabled = isAreaPartsEnabled(this.ad);

      this.getIsRent = () => {
        const { paymentPeriod } = this.ad.bargainTerms;
        return paymentPeriod === 'annual' || paymentPeriod === 'monthly';
      };

      this.initFromOldOffer = () => {
        if (this.ad.canParts && this.ad.minArea && this.ad.minArea > 0) {
          this.isPartsEnabled = true;
          const areaMin = Number(this.ad.minArea);
          if (areaMin && areaMin > 0) {
            const { price, priceType } = this.ad.bargainTerms;
            const partPrice = priceType === 'all' ? Math.round(price / this.ad.totalArea) * areaMin : price;

            this.ad.areaParts = [
              {price: partPrice, area: areaMin},
            ];
          }
        }

        if (this.ad.canParts) {
          this.ad.canParts = false;
        }
        if (this.ad.minArea && this.ad.minArea > 0) { this.ad.minArea = undefined; }
      };

      this.init = () => {
        this.initFromOldOffer();

        if (typeof this.ad.areaParts === 'undefined') {
          this.ad.areaParts = null;
        }
      };
      this.init();

      $scope.$on('addform.clear', () => {
        this.ad.areaParts = undefined;
        this.ad.totalArea = undefined;
        this.isPartsEnabled = false;
      });

      this.partsEnabledClick = (event) => {
        this.isPartsEnabled = !this.isPartsEnabled;

        if (this.isPartsEnabled) {
          if (!this.ad.id || this.ad.areaParts === null || this.ad.areaParts.length === 0) {
            this.ad.areaParts = [
              { price: undefined, area: undefined },
            ];

            // устанливаем таймаут для того чтобы добавленый инпут успел отрендерится
            setTimeout(() => {
              const element = document.querySelector(`input[name~='${this.makeStringPath(0)}']`);
              if (element) {
                element.focus();
              }
            }, 0);

            if (isRent) {
              trackClickIsAreaParts(isOfferEditing, product, siteType);
            }
          }
        } else {
          this.ad.areaParts = null;
        }

        event.preventDefault();
      };

      this.addArea = () => {
        if (this.ad.areaParts) {
          if (this.isPartsEnabled && this.ad.areaParts.length >= 1) {
            this.ad.areaParts.push({ price: undefined, area: undefined });
          } else {
            this.ad.areaParts = [{ price: undefined, area: undefined }];
          }

          const lastIndex = this.ad.areaParts.length - 1;
          // устанавливаем таймаут для того чтобы добавленый инпут успел отрендериться
          setTimeout(() => {
            const element = document.querySelector(`input[name~='${this.makeStringPath(lastIndex)}']`);

            if (element) {
              element.focus();
            }
          }, 0);
        }
      };

      this.removeArea = (index) => {
        if (index < this.ad.areaParts.length) {
          this.ad.areaParts.splice(index, 1);
        }
      };

      this.validation = validation(this.form, 'totalArea', {
        parse: 'Введите число',
        required: 'Укажите общую площадь',
        min: 'Площадь должна быть больше 0',
        max: 'Допустимо не более 7 символов',
      });

      this.makeStringPath = (index) => `areaParts.${index}.area`;
      this.partValidations = [...Array(PARTS_MAX_COUNT)].map((item, index) => {
        let messages;
        if (index === 0) {
          messages = {
            parse: 'Введите число',
            required: 'Укажите Площадь 1',
            min: 'Площадь 1 должна быть больше 0',
            max: 'Площадь 1 не может быть больше или равна общей площади',
          };
        } else {
          messages = {
            parse: 'Введите число',
            min: `Площадь ${index + 1} должна быть больше 0`,
            max: `Площадь ${index + 1} не может быть больше или равна общей площади`,
          };
        }

        return validation(this.form, this.makeStringPath(index), messages);
      });

      let isSendFailEvent = false;
      this.getMessage = (index) => this.partValidations[index] && this.partValidations[index].message();
      this.isInvalid = (index) => {
        if (index > 0 && this.partValidations[index].message() === ' ') {
          return false;
        }

        const resultIsInvalid = this.partValidations[index] && this.partValidations[index].invalid();
        const isFail = this.ad.areaParts &&
          this.ad.areaParts.length > 0 &&
          this.ad.totalArea <= this.ad.areaParts[index].area;

        if (isRent && resultIsInvalid && isFail && !isSendFailEvent) {
          trackFailAreaPart(isOfferEditing, product, siteType);
          isSendFailEvent = true;
        } else if (!isFail) {
          isSendFailEvent = false;
        }

        return resultIsInvalid;
      };

      this.hoverIn = (index) => {
        this.hoverIndex = index;
      };

      this.hoverOut = (index) => {
        if (this.hoverIndex === index) {
          this.hoverIndex = -1;
        }
      };

      this.isAreaInvalid = () => this.validation.invalid() || (this.form.minArea && this.form.minArea.$error.max);

      this.isShowAreaParts = () => this.ad.areaParts && this.ad.areaParts.length > 0;

      this.isShowAddBtn = () => {
        const { areaParts } = this.ad;

        return this.isShowAreaParts() && areaParts.length < PARTS_MAX_COUNT;
      };

      this.partCurrent = (index) => {
        const { areaParts } = this.ad;

        return ((areaParts && areaParts.length > 1) || index > 0) && this.hoverIndex === index;
      };

      this.isPartInvalid = (index) =>
        (index === 0 && this.partValidations[index].invalid()) ||
        (this.form.minArea && this.form.minArea.$error.max);

      this.isPartRequired = (index) => {
        const path = this.makeStringPath(index);

        return index === 0 && this.form[path] && this.form[path].$invalid;
      };

      this.getMaxAreaPart = () => this.ad.totalArea - 1;
    },
    controllerAs: 'ctrl',
    template,
  }))
  .name;
